import { HTTP_Request } from "../utils/interceptor";
import { BASE_URL } from "../utils/constant";
import { Endpoints } from "./endpoint";



// const getUserService = () => {
//   return HTTP_Request.get(BASE_URL + Endpoints.getUser);
// }

const getUserService = (query) => {
  return HTTP_Request.get(BASE_URL + Endpoints.users.list+query);
}

const blockService = (userId) => {
  return HTTP_Request.post(BASE_URL + Endpoints.users.blockUser+`${userId}/block`);
}

const unblockService = (userId) => {
  return HTTP_Request.delete(BASE_URL + Endpoints.users.unBlockUser+`${userId}/block`);
}
const registerUser = (obj)=>{
  return HTTP_Request.post(BASE_URL + Endpoints.users.adminRegisterUser,obj);
}
const updateUser = (userId,obj)=>{
  return HTTP_Request.patch(BASE_URL + Endpoints.users.adminUpdateUser+userId,obj);
}
const deleteUser = (userId)=>{
  return HTTP_Request.delete(BASE_URL + Endpoints.users.deleteUser+userId);
}


const getStats = (filters = {}) => {
  // no date filters => all-time (backend defaults the range to 1970..now).
  // Pass { fromDate, toDate } (YYYY-MM-DD) to scope the dashboard to a period.
  return HTTP_Request.post(BASE_URL + Endpoints.dashboard.stats, { filters });
};

export { getUserService, blockService, unblockService, getStats,registerUser,updateUser,deleteUser };
